// extracted by mini-css-extract-plugin
export default {"menuBlock":"RG-z","title":"SG-z","nav":"TG-z","flexCell":"UG-z","facetLink":"VG-z"};